import '/src/css/app.css'
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

if (document.querySelector('[data-articles-swiper]')) {
  void import('./articles-swiper.js').then((m) => m.initArticleSwipers())
}